<template>
  <q-form ref="form" class="full-width q-pa-md">
    <div class="row" style="height: calc(100vh - 355px)">
      <div
        :class="{
          'col-12': !addMember || id,
          'col-6': addMember && !id
        }"
        class="q-pa-sm"
        style="border-right: 1px solid grey"
      >
        <div class="row items-center" v-if="addMember && !id">
          <div class="col-12">
            <b>Existing Member</b>
          </div>
          <div class="col-12 q-pa-sm">
            <assignMember
              :excludeIDList="[]"
              :id="formData.id"
              :specificMembers="members"
              :dataLoading="membersLoading"
              clearable
              @changed="selectMember"
            />
          </div>
        </div>
        <div class="row items-center" v-if="!dataLoading">
          <div class="col-12" v-if="addMember && !id">
            <b>Or New Member</b>
          </div>
          <div class="col-12 col-md-4 q-pa-sm">
            <q-input
              readonly
              v-model="formData.id"
              v-bind="siteCFG.fields.general"
              label="Waves ID"
            ></q-input>
          </div>
          <div class="col-12 col-md-4 q-pa-sm">
            <q-input
              readonly
              v-model="formData.crm_id"
              v-bind="siteCFG.fields.general"
              label="PAM ID"
            ></q-input>
          </div>
          <div class="col-12 col-md-4 q-pa-sm">
            <q-input
              :readonly="formData.crm_id ? true : false"
              v-model="formData.rfidTag"
              v-bind="siteCFG.fields.general"
              label="RFID Tag"
            ></q-input>
          </div>
          <div class="col-12 col-sm-6 col-md-6 q-pa-sm">
            <q-input
              :readonly="formData.crm_id ? true : false"
              v-model="formData.firstName"
              v-bind="siteCFG.fields.general"
              label="First Name"
              @input="filterMatchingMembers"
            ></q-input>
          </div>
          <div class="col-12 col-sm-6 col-md-6 q-pa-sm">
            <q-input
              :readonly="formData.crm_id ? true : false"
              v-model="formData.lastName"
              v-bind="siteCFG.fields.general"
              label="Last Name"
              @input="filterMatchingMembers"
            ></q-input>
          </div>
          <div class="col-12 col-sm-6 col-md-4 q-pa-sm">
            <q-input
              :readonly="formData.crm_id ? true : false"
              v-model="formData.birthDate"
              v-bind="siteCFG.fields.general"
              label="DOB (YYYY/MM/DD)"
              mask="####/##/##"
              @input="filterMatchingMembers"
            ></q-input>
          </div>
          <div class="col-12 col-sm-6 col-md-4 q-pa-sm">
            <q-select
              :readonly="formData.crm_id ? true : false"
              v-model="formData.gender"
              :options="['M', 'F']"
              v-bind="siteCFG.fields.general"
              label="Gender"
              @change="filterMatchingMembers"
            ></q-select>
          </div>
          <div class="col-12 col-sm-6 col-sm-6 col-md-4 q-pa-sm">
            <q-input
              :readonly="formData.crm_id ? true : false"
              v-model="formData.ethnicityPrimary"
              v-bind="siteCFG.fields.general"
              label="Ethnicity"
            ></q-input>
          </div>

          <div class="col-12 col-md-8 q-pa-sm">
            <q-input
              :readonly="formData.crm_id ? true : false"
              v-model="formData.emailAddress"
              v-bind="siteCFG.fields.general"
              label="Email Address"
            ></q-input>
          </div>
          <div class="col-12 col-md-4 q-pa-sm">
            <q-input
              :readonly="formData.crm_id ? true : false"
              v-model="formData.mobilePhone"
              v-bind="siteCFG.fields.general"
              label="Phone"
            ></q-input>
          </div>

          <!-- <div class="col-12 q-pa-sm">
        <q-input
          readonly
          v-model="formData.address"
          v-bind="siteCFG.fields.general"
          label="Address"
        ></q-input>
      </div>
      <div class="col-12 q-pa-sm">
        <q-input
          readonly
          v-model="formData.suburb"
          v-bind="siteCFG.fields.general"
          label="Suburb"
        ></q-input>
      </div>
      <div class="col-12 q-pa-sm">
        <q-input
          readonly
          v-model="formData.city"
          v-bind="siteCFG.fields.general"
          label="City"
        ></q-input>
      </div> -->
          <div class="col-12" v-if="formData.id">
            <div class="row">
              <div class="col-12 q-py-md">
                <b style="font-size: 24px; margin-right: 20px;">NFC</b>
                <q-btn
                  class="bg-positive text-white"
                  flat
                  label="Add NFC"
                  @click="startNFCScanner(formData)"
                >
                </q-btn>
              </div>
              <div class="col-12">
                <div class="row">
                  <div
                    class="col"
                    v-for="(nfc, index) in nfcList"
                    :key="`nfc_${index}`"
                  >
                    <q-card style="width: 300px;">
                      <q-card-section>
                        <div class="row">
                          <div class="col-12">
                            <b>{{ nfc.serialNumber }}</b>
                          </div>
                          <div class="col-12 q-pt-lg">
                            <q-btn
                              class="bg-negative text-white"
                              flat
                              label="Remove NFC"
                              @click="removeNFC(nfc.id)"
                            ></q-btn>
                          </div>
                        </div>
                      </q-card-section>
                    </q-card>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row items-center" v-else>
          <q-skeleton type="rect" />
        </div>
      </div>
      <div
        v-if="addMember && !id"
        class="col-6 q-pa-sm"
        style="border-left: 1px solid grey"
      >
        <q-scroll-area style="height: 100%">
          <div class="row">
            <div class="col-12">
              <b>Matching Members</b>
            </div>
            <div
              v-for="(member, index) in matchedMembers"
              class="col-12 q-pa-sm"
              :key="`member_${index}`"
            >
              <q-card
                bordered
                flat
                class="q-pa-sm cursor-pointer"
                @click="
                  formData = member;
                  filterMatchingMembers();
                "
              >
                <div class="row">
                  <div class="col-12">
                    <b>{{ member.firstName }} {{ member.lastName }}</b>
                  </div>
                  <div class="col-6">DOB: {{ member.birthDate }}</div>
                  <div class="col-6">Gender: {{ member.gender }}</div>
                </div>
              </q-card>
            </div>
          </div>
        </q-scroll-area>
      </div>
    </div>
  </q-form>
</template>

<script>
import { mapGetters } from "vuex";
import assignMember from "@/components/users/assignMember";
import { NFCScan, NFCWrite } from "@/plugins/NFC";

export default {
  components: { assignMember },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      currentUserData: "auth/currentUserData",
      siteCFG: "settings/siteCFG",
      data: "associations/currentMember",
      dataLoading: "associations/currentMemberLoading",
      members: "associations/membersAll",
      membersLoading: "associations/membersAllLoading",
      nfcList: "associations/nfcListForMember"
    })
  },
  props: {
    id: {
      default: null
    },
    forAssociation: {
      type: Boolean,
      default: false
    },
    addMember: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    data: function() {
      this.init();
    },
    id: function() {
      this.init();
    }
  },
  data: () => ({
    // Extra Data
    formData: {},

    impersonatingUser: false,

    userRoles: [
      "Club Admin",
      "Team Manager",
      "Coach",
      "Sports Coordinator",
      "Junior Coordinator",
      "Athlete"
    ],

    matchedSearchDebounce: null,
    matchedSearchDebounceTime: 500,
    matchedMembers: [],

    // NFC
    nfcScanner: null,

    ndef: null,
    handleReading: null
  }),
  beforeCreate() {},
  mounted() {
    this.init();
    if (this.id) {
      this.$store.dispatch("associations/memberLoadByID", this.id);
      this.$store.dispatch("associations/memberNFCTagsLoadByID", this.id);
    }
  },
  methods: {
    init() {
      if (this.data && this.id && this.data.id == this.id) {
        this.formData = JSON.parse(JSON.stringify(this.data));
      } else {
        this.formData = {};
      }
    },
    async selectMember(id) {
      await this.$store.dispatch("associations/memberLoadByID", id);
      console.log(this.data);
      if (this.data) {
        this.formData = JSON.parse(JSON.stringify(this.data));
        this.filterMatchingMembers();
      } else {
        this.formData = {};
      }
    },
    addMemberToAssociation() {
      this.$emit("loadingStateChanged", true);

      this.formData.associations_id = this.$route.params.id;
      // this.formData.ref_id = ref_id;

      this.$refs.form.validate().then(result => {
        if (result) {
          this.$store
            .dispatch("associations/addMember", this.formData)
            .then(result => {
              this.$emit("loadingStateChanged", false);
              if (result.Result == "Success") {
                this.$emit("close", true);
                this.formData = {};
                this.$q.notify({
                  position: "top-right",
                  type: "positive",
                  message: result.Response.Message
                });
                // this.$store.dispatch(dispatch, ref_id);
              } else {
                this.$q.notify({
                  position: "top-right",
                  type: "negative",
                  message: result.Response.Message
                });
              }
            });
        } else {
          this.$emit("loadingStateChanged", false);
        }
      });
    },
    save() {
      this.$emit("loadingStateChanged", true);

      this.$refs.form.validate().then(result => {
        if (result) {
          this.$store
            .dispatch("associations/saveMember", this.formData)
            .then(result => {
              this.$emit("loadingStateChanged", false);
              if (result.Result == "Success") {
                this.$emit("close", true);
                this.formData = {};
                this.$q.notify({
                  position: "top-right",
                  type: "positive",
                  message: result.Response.Message
                });
                // this.$store.dispatch(dispatch, ref_id);
              } else {
                this.$q.notify({
                  position: "top-right",
                  type: "negative",
                  message: result.Response.Message
                });
              }
            });
        } else {
          this.$emit("loadingStateChanged", false);
        }
      });
    },

    // NFC
    async removeNFC(id) {
      try {
        let response = await this.$store.dispatch("associations/removeNFC", {
          id: id
        });
        if (response.Result == "Success") {
          this.$q.notify({
            position: "top-right",
            type: "positive",
            message: response.Response.Message
          });
          this.$store.dispatch("associations/memberNFCTagsLoadByID", this.id);
        } else {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: response.Response.Message
          });
        }
      } catch (error) {
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "There was an error removing the NFC tag."
        });
      }
    },

    async handleNFCScan(message, serialNumber, extraData) {
      this.ndef.removeEventListener("reading", this.handleReading);
      console.log(this.nfcScanner);

      // ADD NFC to Member
      try {
        let response = await this.$store.dispatch(
          "associations/addNFCToMember",
          {
            id: extraData.id,
            serialNumber: serialNumber,
            associations_id: this.currentUserData.currentAssociation_id
          }
        );
        this.$q.notify({
          position: "top-right",
          type: "positive",
          message: response.Response.Message
        });
      } catch (error) {
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "There was an error, Please try again later"
        });
      }
    },
    async startNFCScanner(row) {
      const { ndef, handleReading } = await NFCScan(
        this,
        this.handleNFCScan,
        row
      );
      this.ndef = ndef;
      this.handleReading = handleReading;
      // NFCWrite(this, {
      //   records: [
      //     {
      //       recordType: "text",
      //       data: {
      //         text: `${row.firstName} ${row.lastName} - ${row.id} - ${row.crm_id}`
      //       }
      //     }
      //   ]
      // });
    },

    filterMatchingMembers() {
      clearTimeout(this.matchedSearchDebounce);
      this.matchedSearchDebounce = setTimeout(() => {
        if (this.formData.id) {
          this.matchedMembers = [];
        } else {
          let members = JSON.parse(JSON.stringify(this.members)).filter(m => {
            if (this.formData.firstName) {
              let matchFound =
                `${m.firstName}`
                  .toLowerCase()
                  .indexOf(this.formData.firstName.toLowerCase()) > -1;
              if (matchFound != true) {
                return false;
              }
            }

            if (this.formData.lastName) {
              let matchFound =
                `${m.lastName}`
                  .toLowerCase()
                  .indexOf(this.formData.lastName.toLowerCase()) > -1;
              if (matchFound != true) {
                return false;
              }
            }

            if (this.formData.gender && this.formData.gender != m.gender) {
              return false;
            }

            if (
              this.formData.birthDate &&
              this.formData.birthDate != m.birthDate
            ) {
              return false;
            }

            if (!this.formData.firstName && !this.formData.lastName) {
              return false;
            }

            return true;
          });
          this.matchedMembers = members;
        }
      }, this.matchedSearchDebounceTime);
    }
  }
};
</script>

<style lang="scss" scoped>
.memberFormSection {
  border: 1px solid grey;
}
</style>
